


















































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import { bus } from '@/pages/transitweb/main'

import VuePlotly from '@statnett/vue-plotly';

import { mixins } from 'vue-class-component';
import QueryEndpointData from './dataquery-mixin';

import BorderCrossingsBarChart from './BorderCrossingsBarChart.vue';
import Metrics from './Metrics.vue';
import MetricsHistogram from './MetricsHistogram.vue';
import { eventLoading } from '@/components/sce/EventLoading';// This class controls loading state to update progress bar

@Component({
    components: {
        VuePlotly,
        Metrics,
        MetricsHistogram,
        BorderCrossingsBarChart
    }
})
export default class SCEMap extends mixins(QueryEndpointData) {

    @Getter('auth/isAiAssistantUser') isAiAssistantUser!: boolean;

    @Prop() spatial_type_value!: string;
    @Prop() lga_items!: string[];
    @Prop() state_items!: string[];
    @Prop() spatialBorderCrossing!: boolean;

    histogramVisible = false;
    selectedMetric = '';
    metricKey = '';

    get densityMapUrl() {
        return process.env.VUE_APP_BACKEND_BASE + "/supplychainexplorer/map";
    }

    mounted() {
        // Load the map data when it is mounted.
        this.loadData(this.densityMapUrl);
    }

    created() {
        eventLoading.$on('loading', this.setLoading);
    }

    beforeDestroy() {
        eventLoading.$off('loading', this.setLoading);
    }

    setLoading(isLoading: boolean) {
        this.loading = isLoading;
    }

    @Watch('updateRequired')
    reloadData(newVal: any, oldVal: any) {
        // Reload the data
        this.loadData(this.densityMapUrl);
    }

    ask_assistant() {
        var question = this.create_question()
        bus.$emit('assistant', { content: question })
    }

    create_question() {

        // Build a question  for the assistant
        var question = `Please tell me about the supply chain movements of ${this.commodity}` //and ${this.metric.text}

        if (this.spatial_selection) {
            // If there was a spatial filter add in the region anf the filtered leg of the supply chain.
            var region = "";
            if (this.spatial_type_value === "lga") {
                region = (this.lga_items.filter((item: any) => item.code === this.spatial_selection)[0] as any).name;
            } else if (this.spatial_type_value === "state") {
                region = (this.state_items.filter((item: any) => item.code === this.spatial_selection)[0] as any).name;
            }
            var direction = this.supply_chain_leg_direction(this.supply_chain_leg) == "orig" ? "originating from" : "destined to"
            question = question.concat(` related to ${this.supply_chain_leg.replace("_", " & ")} ${direction} ${region}. `)
        }
        else {
            // Ask about all of australia.
            question = question.concat(` across Australia. `)
        }

        // Add some context for the the supply chain leg map which was honked.
        question = question.concat(`I am particularly interested in the specific enterprise regions that the commodity travels ${this.config.direction} which have a key role in the ${this.config.title.toLowerCase()} part of the supply chain. `)
        return question
    }

    get mapData() {

        var region_items = this.spatial_type_value == 'lga' ? this.lga_items : this.state_items
        var regionItemNameLookup = new Map(region_items.map((item: any) => [item.code, item.name]));

        // Get the plotly data object for the appropriate supply chain leg map.
        if (["node", "lga", "state"].includes(this.metric.value)) {

            return [{
                type: "choroplethmapbox",
                name: this.spatial_type.text,
                geojson: this.spatial_type.geojson,
                locations: this.data.map((item: any) => item[this.regions]),
                meta: this.data.map((item: any) => item[this.metric.value]),
                customdata: this.data.map((item: any) => {
                    var regionCode = item[this.regions];
                    var regionName = regionItemNameLookup.get(regionCode) || 'Unknown';
                    return [this.metric.text, this.config.map_id, this.metric.valuesuffix, regionName];
                }),
                hovertemplate: "%{customdata[0]}: %{meta:.0f} %{customdata[2]}<extra>%{customdata[3]}</extra>",
                z: this.data.map((item: any) => item[this.metric.value]),
                colorscale: [[0, 'white'], [0.4, 'rgb(63,81,181)'], [1, 'red']], // If only one value returned, plotly puts it in the middle of the color scale instead of mapping it to the maximum color..
            }]

        } else {

            return [{
                type: "choroplethmapbox",
                name: this.spatial_type.text,
                geojson: this.spatial_type.geojson,
                locations: this.data.map((item: any) => item[this.regions]),
                meta: this.data.map((item: any) => item[this.metric.value]),
                customdata: this.data.map((item: any) => {
                    var regionCode = item[this.regions];
                    var regionName = regionItemNameLookup.get(regionCode) || 'Unknown';
                    return [this.metric.text, this.config.map_id, regionName];
                }),
                hovertemplate: "%{customdata[0]}: %{meta:.2%}<extra>%{customdata[2]}</extra>",
                z: this.data.map((item: any) => Math.log10(item[this.metric.value])),
                zmin: -4,
                zmax: 0,
                colorscale: [[0, 'white'], [0.4, 'rgb(63,81,181)'], [1, 'red']],
                colorbar: {
                    tickvals: [-4, -3, -2, -1, 0],
                    ticktext: ['0.01%', '0.1%', '1%', '10%', '100%'],
                    tickmode: 'array',
                },
            }];
        }
    }

    get mapLayout() {
        // Get the plotly layout object for the appropriate supply chain leg map.
        return {
            mapbox: {
                style: 'light',
                center: {
                    lon: 134,
                    lat: -28.3
                },
                zoom: 2.7
            },
            height: 370,
            autosize: true,
            margin: { t: 6, b: 0, l: 10, r: 10 }
        };
    }

    densityMapOnClick(e: any) {
        this.$emit('update-spatial-params', e);
    }

    hasMapData(mapData: any): boolean {
        return mapData[0]?.z?.some((v: any) => v != null);
    }

    onMetricClicked(metricKey: string, title: string) {
        this.metricKey = metricKey;
        this.selectedMetric = title;
        this.histogramVisible = true;
    }

    get visible(): 'loading' | 'no-data' | 'histogram' | 'map' {
        if (this.loading) return 'loading';
        if (!this.hasMapData(this.mapData)) return 'no-data';
        if (this.histogramVisible) return 'histogram';
        return 'map';
    }

    onCrossingSelected(payload: { clickedValue: number; map_id: string }) {
        this.$emit('crossing-selected', payload)
    }

}


